import { Injectable } from '@angular/core';
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {catchError, map, Observable, throwError} from "rxjs";
import {RemMotivoDespacho} from "../models/RemMotivoDespacho";

@Injectable({
  providedIn: 'root'
})
export class MotivoService {
  private readonly motivoUrl = environment.remMotivoUrl;

  constructor(private readonly httpClient: HttpClient) { }

  getMotivos(): Observable<RemMotivoDespacho[]> {
    return this.httpClient.get<RemMotivoDespacho[]>(this.motivoUrl ).pipe(
      map(
        motivos => {
          return motivos.map((motivo) => {
            return RemMotivoDespacho.transformMotivo(motivo);
          })
        })
    );
  }

  findActiveMotivo(codMotivo: String): Observable<RemMotivoDespacho> {
    return this.httpClient.get<RemMotivoDespacho>(this.motivoUrl + '/active/' + codMotivo).pipe(
      map(motivo => {
        return RemMotivoDespacho.transformMotivo(motivo);
      })
    );
  }

  addUpdateMotivo(motivo: RemMotivoDespacho, add: boolean): Observable<RemMotivoDespacho> {
    if (add) {
      return this.addMotivo(motivo);
    } else {
      return this.updateMotivo(motivo);
    }
  }

  addMotivo(motivo: RemMotivoDespacho): Observable<RemMotivoDespacho> {
    return this.httpClient.post<RemMotivoDespacho>(this.motivoUrl , motivo).pipe(
      map((res) => {
        return RemMotivoDespacho.transformMotivo(res);
      }),
      catchError((err) => {
        console.log("Saving failed for motivo add: " + motivo);
        return throwError(err);
      })
    );
  }

  updateMotivo(motivo: RemMotivoDespacho): Observable<RemMotivoDespacho> {
    return this.httpClient.put<RemMotivoDespacho>(this.motivoUrl , motivo).pipe(
      map((res) => {
        return RemMotivoDespacho.transformMotivo(res);
      }),
      catchError((err) => {
        console.log("Saving failed for motivo Update: " + motivo);
        return throwError(err);
      })
    );
  }
}
